import { truncate } from 'lodash'

export const isUrl = (url) => {
  try {
    return Boolean(new URL(url))
  } catch (e) {
    return false
  }
}

export const removeProtocol = (url) => url.replace(/(^\w+:|^)\/\//, '')

export const truncateMSTeamsUrl = (url) =>
  truncate(removeProtocol(url), {
    length: 34
  })
